//Modules
import React from "react"
import { Router } from "@reach/router"
//Components
import Layout from "../components/Layout/Layout"
import DemoLessons from "../clientPages/DemoLessons"
import Gallery from "../clientPages/Gallery"
import Login from "../clientPages/Login"
import PrivateRoute from "../components/PrivateRoute/PrivateRoute"

const Protected = () => {
  return (
    <Layout>
      <Router basepath="/protected">
        <PrivateRoute path="/demo-lessons" component={DemoLessons} />
        <PrivateRoute path="/gallery" component={Gallery} />
        <PrivateRoute path="/login" component={Login} />
      </Router>
    </Layout>
  )
}
export default Protected
